<div class="cc-modal">
  <svg class="cc-icon-defs" xmlns="http://www.w3.org/2000/svg">
    <symbol id="mss-i-search" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 4.99L20.49 19zm-6 0A4.5 4.5 0 1 1 14 9.5 4.5 4.5 0 0 1 9.5 14"/></symbol>
    <symbol id="mss-i-x" viewBox="0 0 24 24"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></symbol>
    <symbol id="mss-i-chev-left" viewBox="0 0 24 24"><path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"/></symbol>
    <symbol id="mss-i-chev-right" viewBox="0 0 24 24"><path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"/></symbol>
  </svg>

  <header class="cc-modal-h">
    <div class="cc-modal-h-l">
      <svg class="cc-modal-icon"><use href="#mss-i-search"/></svg>
      <h2>{{ moduleToSearch?.label | titlecase }} search</h2>
    </div>
    <button class="cc-modal-close" (click)="cancel()" aria-label="Close" type="button">
      <svg><use href="#mss-i-x"/></svg>
    </button>
  </header>

  <div class="cc-modal-body">
    <!-- Search form (collapsible) -->
    @if (moduleToSearch) {
      <section class="cc-search">
        @if (!searchCollapsed) {
          <form class="cc-search-form" (ngSubmit)="search()" novalidate>
            <div class="cc-search-fields">
              @for (_field of searchFields; track _field.fieldName; let _i = $index) {
                <div class="cc-search-field" [class.cc-zip-field]="_field?.inputType === 'Address Part' && _field?.fieldName?.includes('zip')">
                  <field-type-edit
                    [fieldPassedIn]="_field"
                    [recordPassedIn]="searchTerms"
                    [fullModule]="moduleToSearch"
                    [hideRequired]="true"
                    [searchMode]="true"
                    (relatedFieldChosen)="relatedFieldChosen($event)">
                  </field-type-edit>
                  @if (_field?.fieldName?.includes('zip')) {
                    <div class="cc-zip-radius">
                      <label class="cc-zip-radius-label">Radius</label>
                      <input class="cc-input cc-zip-radius-input"
                             type="number"
                             placeholder="Radius"
                             [(ngModel)]="searchTerms.radius"
                             [ngModelOptions]="{standalone: true}">
                    </div>
                  }
                </div>
              }
            </div>

            <div class="cc-search-foot">
              <button type="submit" class="cc-btn-primary">
                <svg><use href="#mss-i-search"/></svg>
                Search
              </button>
              <button type="button" class="cc-btn-secondary" (click)="clear()">Clear</button>
              @if (hasSearched) {
                <button type="button" class="cc-link-btn" (click)="collapseSearch()">Hide search</button>
              }
            </div>
          </form>
        }

        @if (searchCollapsed) {
          <div class="cc-search-collapsed">
            <div class="cc-chip-row">
              @for (chip of activeFilterChips; track chip.key) {
                <span class="cc-chip">
                  <strong>{{ chip.label }}:</strong> {{ chip.value }}
                  <button class="cc-chip-x" (click)="clearFilter(chip.key)" aria-label="Remove" type="button">×</button>
                </span>
              }
              @if (activeFilterChips.length === 0) {
                <span class="cc-chip-empty">No active filters</span>
              }
              <button class="cc-link-btn" (click)="expandSearch()" type="button">Edit search</button>
            </div>
          </div>
        }
      </section>
    }

    <!-- Results count + bulk bar -->
    @if (hasSearched && !isLoading) {
      <div class="cc-results-count">
        <span><strong>{{ totalResults | number:'1.0-0' }}</strong> {{ moduleToSearch?.label | lowercase }} found</span>
        @if (multiSelectMode && selectedCount > 0) {
          <span class="cc-selected"> · {{ selectedCount }} selected</span>
        }
      </div>

      @if (multiSelectMode && selectedCount > 0) {
        <div class="cc-bulk-bar">
          <div class="cc-bulk-l"><strong>{{ selectedCount }}</strong> selected</div>
          <div class="cc-bulk-r">
            <button type="button" class="cc-btn-text" (click)="onSelectAllClick()" [disabled]="isSelectingAll">
              @if (!isSelectingAll) {
                <span>Select all ({{ totalResults | number:'1.0-0' }})</span>
              } @else {
                <span class="cc-bulk-progress">
                  <span class="cc-spinner cc-spinner-sm"></span>
                  Selecting…
                </span>
              }
            </button>
            <button type="button" class="cc-btn-text" (click)="deselectAll()">Deselect all</button>
          </div>
        </div>
      }
    }

    <!-- Empty + loading + table -->
    @if (isLoading) {
      <div class="cc-empty">
        <span class="cc-spinner"></span>
        <p>Searching…</p>
      </div>
    } @else if (!hasSearched) {
      <div class="cc-empty">
        <svg class="cc-empty-icon"><use href="#mss-i-search"/></svg>
        <h3>Search to find {{ moduleToSearch?.label | lowercase }}</h3>
        <p>Use the filters above to find the records you're looking for.</p>
      </div>
    } @else if (data.length === 0) {
      <div class="cc-empty">
        <svg class="cc-empty-icon"><use href="#mss-i-search"/></svg>
        <h3>No {{ moduleToSearch?.label | lowercase }} match those filters</h3>
        <p>Try widening the search or clearing a filter.</p>
        <button type="button" class="cc-btn-secondary" (click)="clear()">Clear filters</button>
      </div>
    } @else {
      <div class="cc-table-wrap">
        <table class="cc-table">
          <thead>
            <tr>
              @if (multiSelectMode) {
                <th class="cc-th-check">
                  <input type="checkbox"
                         [checked]="allOnPageSelected"
                         [indeterminate]="someOnPageSelected"
                         (change)="toggleAllOnPage()">
                </th>
              }
              @for (col of gridColumns; track col?.fieldName) {
                @if (col) {
                  <th [attr.data-sort]="sortAttr(col)" (click)="onSortClick(col)">{{ col.label }}</th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (row of data; track row._id) {
              <tr [class.is-selected]="multiSelectMode && _tableService.isItemSelected(row._id)"
                  (click)="onRowClick(row)">
                @if (multiSelectMode) {
                  <td class="cc-td-check">
                    <input type="checkbox"
                           [checked]="_tableService.isItemSelected(row._id)"
                           (click)="$event.stopPropagation(); toggleRow(row)">
                  </td>
                }
                @for (col of gridColumns; track col?.fieldName) {
                  @if (col) {
                    <td>
                      @if (col.type) {
                        <field-type-formatter
                          [doDebug]="false"
                          [fieldPassedIn]="col"
                          [fullModule]="moduleToSearch"
                          [relateToLinkInfo]="col.ref"
                          [moduleName]="moduleToSearch.name"
                          [recordPassedIn]="row">
                        </field-type-formatter>
                      }
                    </td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <footer class="cc-modal-foot">
    <span class="cc-page-info">
      @if (hasSearched && !isLoading && totalResults > 0) {
        <select class="cc-page-size" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">
          @for (n of pageSizeOptions; track n) {
            <option [ngValue]="n">{{ n }}</option>
          }
        </select>
        <span class="cc-page-range">{{ rangeStart }}–{{ rangeEnd }} of {{ totalResults | number:'1.0-0' }}</span>
        <button type="button" class="cc-page-btn" (click)="prevPage()" [disabled]="page === 0">
          <svg><use href="#mss-i-chev-left"/></svg>
        </button>
        <button type="button" class="cc-page-btn" (click)="nextPage()" [disabled]="!hasNextPage">
          <svg><use href="#mss-i-chev-right"/></svg>
        </button>
      }
    </span>
    @if (multiSelectMode) {
      <div class="cc-foot-actions">
        <button type="button" class="cc-btn-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="cc-btn-primary" (click)="confirm()"
                [disabled]="disableSelectBtnOnEmptyValues && selectedCount === 0">
          Select@if (selectedCount > 0) {<span> ({{ selectedCount }})</span>}
        </button>
      </div>
    }
  </footer>
</div>
